import React from 'react';
import { motion } from 'framer-motion';
import { Wind, ArrowRight } from 'lucide-react';
export function EmotionalHook() {
  return <section className="bg-[#9B4D4D] py-20 text-white text-center px-4" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto" data-id="element-36">
        <Wind className="h-12 w-12 mx-auto mb-6 text-[#B8A9C9] opacity-80" data-id="element-37" />
        <h2 className="text-3xl md:text-4xl font-serif font-medium mb-8 leading-relaxed" data-id="element-38">
          🧠 Esto no es ansiedad "mental"
        </h2>

        <div className="space-y-6 text-lg md:text-xl font-light text-white/90 mb-10" data-id="element-39">
          <p data-id="element-40">
            La ansiedad no nació en tus pensamientos. No fue tu historia. No fue
            tu carácter.
          </p>
          <p className="font-medium text-white text-2xl" data-id="element-41">
            Nació en un sistema nervioso tenso, hipervigilante, que aprendió a
            sobrevivir.
          </p>
          <p data-id="element-42">
            Y ese cuerpo sigue enviando señales de peligro… aunque la amenaza ya
            no esté.
          </p>

          <div className="bg-white/10 rounded-xl p-6 text-left max-w-lg mx-auto mt-8 border border-white/10" data-id="element-43">
            <p className="font-bold text-[#C4973B] mb-4 uppercase tracking-wider text-sm" data-id="element-44">
              Por eso:
            </p>
            <ul className="space-y-3" data-id="element-45">
              {['No descansas aunque duermas', 'Todo cansa, incluso lo que amas', 'Tu mente no se apaga', 'Tu cuerpo nunca se siente realmente seguro'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-46">
                  <div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#C4973B]" data-id="element-47" />
                  <span data-id="element-48">{item}</span>
                </li>)}
            </ul>
          </div>

          <p className="font-bold text-white text-2xl pt-8" data-id="element-49">
            👉 No estás loca. Estás alerta.
          </p>
        </div>

        <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#C4973B] text-white font-bold py-4 px-8 rounded-full shadow-lg hover:bg-[#B08632] hover:scale-105 transition-all text-lg" data-id="element-50">
          Quiero sentirme a salvo otra vez
          <ArrowRight className="h-5 w-5" data-id="element-51" />
        </a>
      </motion.div>
    </section>;
}